import { useQuery } from '@tanstack/react-query';

import { HintCoverageAccountType, getHintRegionComposition } from '~/services/ConnectionGoogleService';

export const hintRegionCompositionQueryKeys = {
  all: ['hintRegionComposition'] as const,
  composition: (accountType: HintCoverageAccountType) => [...hintRegionCompositionQueryKeys.all, accountType] as const,
};

export function useHintRegionComposition(accountType: HintCoverageAccountType) {
  return useQuery({
    queryKey: hintRegionCompositionQueryKeys.composition(accountType),
    queryFn: async ({ signal }) => {
      const response = await getHintRegionComposition(accountType, { signal });
      return response.result;
    },
    enabled: !!accountType,
  });
}
